import React, { useEffect, useState, useRef } from 'react';
import { Col, Form } from 'react-bootstrap';
import { InputFormControl } from '../../Atoms/InputFormControl/InputFormControl';
import { SelectFormControl } from '../../Atoms/SelectFormControl/SelectFormControl';
import CustomCheck from '../../Atoms/CustomCheck/CustomCheck';
import MessageError from '../../Atoms/MessageError/MessageError';
import InfoErrorCode from '../../Atoms/InfoErrorCode/InfoErrorCode';
import Spinner from '../../Atoms/Spinner/Spinner';
import { useForm, Controller } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import SpinnerMiddleware from '../../Atoms/SpinnerMiddleware/SpinnerMiddleware';
import Select from 'react-select';
import { useCountries } from '../../../Core/Hooks/HookGetCountries/useCountriesList';
import { HttpClient } from '../../../Domain/Utils/ApiUtilies/Fetch/Fetch';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';

import {
    DIV_LIMIT_FILE,
} from '../../../Domain/Settings/Constants/Constants';

import {
    GET_CITIES,
    API_DOCUMENT_TYPE_COUNTRIES,
} from '../../../Domain/Redux/Paths';

const selectCustomStyles = {
    option: (provided, state) => ({
        ...provided,
        borderBottom: '1px dotted #ddd',
        color: state.isSelected ? '#000' : '#333',
        padding: 5,
        backgroundColor: state.isSelected ? '#eee' : 'transparent'
    }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition };
    },
    control: (provided, state) => ({
        ...provided,
        border: 'none',
        borderRadius: 0,
        borderBottom: '1px solid #ddd'
    })
};

const ReferenceForm = ({
    parameters,
    control,
    errors,
    watch,
    getValues,
    setValue,
    selectStyles,
    referenceTypeList,
    checkedTruthfulness,
    handleCheck,
    empyCheck,
    errorSameReference,
    defaultValues,
    register,
    nameForm,
    setNameForm
}) => {
    const [countryDocumentRef, setCountryDocumentRef] = useState('');
    const { countriesList, alpha2codeCountries, phoneTypeList } = useCountries();
    const [citiesListDoc, setCitiesListDoc] = useState([]);
    const [disableCity, setDisableCity] = useState(true);
    const [documentTypeListRef, setDocumentTypeListRef] = useState([]);
    const inputFileRef = useRef(null);
    const [fileNameRef, setFileNameRef] = useState('');
    const [typeFileRef, setTypeFileRef] = useState('');
    const [fileRef, setFileRef] = useState(null);
    const [activeFileNameRef, setActiveFileNameRef] = useState(false);
    const [errorInvalidFileRef, setErrorInvalidFileRef] = useState(false);
    const [errorInvalidSizeRef, setErrorInvalidSizeRef] = useState(false);
    const [errorEmptyFileRef, setErrorEmptyFileRef] = useState(false);
    const [cityDocumentRef, setCityDocumentRef] = useState('');
    const [loadFileRef, setLoadFileRef] = useState(false);
    const [formValues, setFormValues] = useState([]);
    const initialized = useRef(false);

    useEffect(() => {
        if (!initialized.current && defaultValues) {
            Object.entries(defaultValues).forEach(([key, val]) => {
                if (val !== undefined) {
                    control.setValue(key, val);
                }
            });

            // Asignar country_code_ref
            if (defaultValues.country_code_ref && alpha2codeCountries?.length > 0) {
                const countryMatch = alpha2codeCountries.find(
                    (c) => c.dial_code === defaultValues.country_code_ref
                );
                if (countryMatch) {
                    setValue('country_code_ref', countryMatch);
                }
            }

            // Asignar phone_type_ref
            if (defaultValues.phone_type_ref && phoneTypeList?.length > 0) {
                const phoneTypeMatch = phoneTypeList.find(
                    (t) => t.id === defaultValues.phone_type_ref
                );
                if (phoneTypeMatch) {
                    setValue('phone_type_ref', phoneTypeMatch);
                }
            }

            initialized.current = true;
        }
    }, [defaultValues, alpha2codeCountries, phoneTypeList]);


    useEffect(() => {
        if (defaultValues) {
            const currentCountryCodeRef = getValues('country_code_ref');
            const currentPhoneTypeRef = getValues('phone_type_ref');

            if (
                !currentCountryCodeRef &&
                defaultValues.country_code_ref &&
                alpha2codeCountries?.length > 0
            ) {
                const countryMatch = alpha2codeCountries.find(
                    (c) => c.dial_code === defaultValues.country_code_ref
                );
                if (countryMatch) {
                    setValue('country_code_ref', countryMatch);
                }
            }

            if (
                !currentPhoneTypeRef &&
                defaultValues.phone_type_ref &&
                phoneTypeList?.length > 0
            ) {
                const phoneTypeMatch = phoneTypeList.find(
                    (t) => t.id === defaultValues.phone_type_ref
                );
                if (phoneTypeMatch) {
                    setValue('phone_type_ref', phoneTypeMatch);
                }
            }
        }
    }, [defaultValues, alpha2codeCountries, phoneTypeList, getValues, setValue]);


    useEffect(() => {
        setValue('countryDocumentRef', countryDocumentRef?.pk !== '' ? countryDocumentRef : '');
        const pkCountry = countryDocumentRef?.pk ?? countryDocumentRef?.[0]?.pk;
        if (pkCountry !== undefined)
            HttpClient.GET(GET_CITIES, { country_id: pkCountry }).then((cities) => {

                setCitiesListDoc(cities.results || []);
                if (cityDocumentRef?.pk) {
                    const cityCountry = cities?.results?.find((item) => item.pk === cityDocumentRef.pk);
                    console.log(cityCountry)
                    if (!cityCountry) {
                        setCityDocumentRef('');
                    } else {
                        setCityDocumentRef(cityDocumentRef);
                    }
                }
            });
    }, [countryDocumentRef]);

    useEffect(() => {
        const pkCountry = countryDocumentRef?.pk ?? countryDocumentRef?.[0]?.pk;
        HttpClient.GET(API_DOCUMENT_TYPE_COUNTRIES, {
            country: pkCountry,
            component: COMPONENTS.COUNTRY,
            component_city: COMPONENTS.CITY
        }).then((data) => {
            setDisableCity(false);
            setDocumentTypeListRef(data?.content);
        });
    }, [countryDocumentRef]);

    const handleLoadFileRef = (name) => {
        const fileInput = inputFileRef.current;
        if (!fileInput || !fileInput.files || !fileInput.files[0]) return;

        const file = fileInput.files[0];
        const typeFile = file.name.split('.').pop().toLowerCase();

        if (typeFile === 'pdf') {
            if (
                file.size < (DIV_LIMIT_FILE.limit_mb ?? parseInt(parameters?.LIMIT_FILE?.value))
            ) {
                setErrorInvalidSizeRef(false);
                setErrorInvalidFileRef(false);
                setErrorEmptyFileRef(false);
                setFileNameRef(file.name);
                setTypeFileRef(typeFile);
                setActiveFileNameRef(true);
                const reader = new FileReader();
                setLoadFileRef(true);
                reader.onload = (event) => {
                    const base = ';base64,';
                    const len = event.target.result.indexOf(base) + base.length;
                    const f = event.target.result.substring(len);
                    setLoadFileRef(false);
                    // Guardar en el estado global de formValues
                    setFormValues((prev) => ({
                        ...prev,
                        documentFileRef: f,
                        codeRef: typeFile
                    }));
                    setValue('documentFileRef', f);
                };
                reader.readAsDataURL(file);
                return;
            } else {
                setErrorInvalidSizeRef(true);
                setActiveFileNameRef(false);
                setErrorInvalidFileRef(false);
                setErrorEmptyFileRef(false);
                return;
            }
        } else {
            setErrorInvalidFileRef(true);
            setActiveFileNameRef(false);
            setErrorEmptyFileRef(false);
            return;
        }
    };

    const removeResource = (evt) => {
        evt.preventDefault();
        setFileNameRef('');
        setTypeFileRef('');
        setActiveFileNameRef(false);
        setFileRef(null);
    };
    setNameForm(parameters?.TITLE_FORM_CREATE_REFERENCE?.value);
    return (
        <>
            <p className="text-black bold">
                {nameForm}
            </p>
            {errorSameReference?.show && (
                <InfoErrorCode color="black" message={errorSameReference?.message} />
            )}
            <label className="description-label" htmlFor="firstNameRef">
                {watch('firstNameRef') && parameters?.INF_MSG_156?.value}
            </label>
            <InputFormControl
                name="firstNameRef"
                type="text"
                rules={{ required: parameters?.RQD_MSG_8?.value }}
                control={control}
                placeholder={parameters?.INF_MSG_156?.value}
                error={errors?.firstNameRef}
                border
                customHeight="2.5rem"
            />
            <label className="description-label" htmlFor="lastNameRef">
                {watch('lastNameRef') && parameters?.MSG_INF_158?.value}
            </label>
            <InputFormControl
                name="lastNameRef"
                type="text"
                rules={{ required: parameters?.RQD_MSG_8?.value }}
                control={control}
                placeholder={parameters?.MSG_INF_158?.value}
                error={errors?.lastNameRef}
                border
                customHeight="2.5rem"
            />
            <label className="description-label" htmlFor="Email">
                {watch('email_ref') && parameters?.CREATE_ACCOUNT_EMAIL?.value}
            </label>
            <InputFormControl
                name="email_ref"
                control={control}
                type="email"
                rules={{
                    required: parameters?.RQD_MSG_8?.value,
                    pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: 'Correo inválido.'
                    }
                }}
                placeholder={parameters?.CREATE_ACCOUNT_EMAIL?.value}
                error={errors?.email_ref}
                border
                customHeight="2.5rem"
            />
            <Form.Group className="my-0">
                <Col xs={12} lg={12} className="mb-2 mt-1">
                    <label className="description-label" htmlFor="phone_type_ref">
                        {watch('phone_type_ref') && parameters?.PHONE_TYPE_LABEL?.value}
                    </label>
                    <SelectFormControl
                        name="phone_type_ref"
                        control={control}
                        options={phoneTypeList}
                        nameOptionValue="pk"
                        rules={{ required: parameters?.RQD_MSG_3?.value }}
                        error={errors?.phone_type_ref}
                        renderOptionLabel={(option) => option.name}
                        placeholder={parameters?.PHONE_TYPE_LABEL?.value}
                        selectStyles={selectStyles}
                    />
                </Col>
                {watch('phone_number_ref') && (
                    <label className="description-label" htmlFor="phone_number_ref">
                        {'Número de teléfono'}
                    </label>
                )}
                <div className="row" style={{ alignItems: 'flex-end' }}>
                    <Col lg={4}>
                        {parameters?.PH_MSG_3?.value ? (
                            <SelectFormControl
                                name="country_code_ref"
                                control={control}
                                options={alpha2codeCountries.filter((c) => c.dial_code)}
                                nameOptionValue="abbreviation_name"
                                rules={{
                                    required: parameters?.RQD_MSG_3?.value,
                                    maxLength: { value: 11, message: parameters?.TXT_ERR_PHONE?.value }
                                }}
                                error={errors?.phoneCode}
                                renderOptionLabel={(o) => (
                                    <>
                                        <img src={o.flag} alt="flag" style={{ width: 20, marginRight: 5 }} />
                                        {`${o.abbreviation_name} ${o.dial_code}`.toUpperCase()}
                                    </>
                                )}
                                placeholder={parameters?.PH_MSG_3?.value}
                                value={getValues('country_code_ref')}
                                defaultValue={getValues('country_code_ref')}
                                selectStyles={selectStyles}
                            />
                        ) : (
                            <Spinner backgroundColor="black" />
                        )}
                    </Col>
                    <Col lg={7} className="mt-lg-0 mt-2">
                        <InputFormControl
                            name="phone_number_ref"
                            control={control}
                            type="number"
                            rules={{
                                required: parameters?.LMS_PTFORM_MANDATORY_FIELD?.value,
                                pattern: { value: /^[0-9]+$/, message: parameters?.ERR_MSG_3?.value }
                            }}
                            placeholder={'Número de teléfono'}
                            error={errors?.phone_number_ref}
                            border
                            customHeight="2.5rem"
                        />
                    </Col>
                </div>
            </Form.Group>
            <Form.Group>
                <Col lg={6}>
                    <label className="description-label" htmlFor="referenceType">
                        {watch('referenceType') && parameters?.REFERENCE_TYPES_PH?.value}
                    </label>
                    <SelectFormControl
                        name="referenceType"
                        control={control}
                        options={referenceTypeList}
                        nameOptionValue="name"
                        renderOptionLabel={(option) => option.name}
                        rules={{ required: parameters?.RQD_MSG_8?.value }}
                        error={errors?.referenceType}
                        placeholder={parameters?.PH_MSG_3?.value}
                        selectStyles={selectStyles}
                    />
                </Col>
            </Form.Group>
            {/* País de expedición */}
            <Col lg={12}>
                <Form.Group className="mb-2" controlId="countryDocumentRef">
                    <label className="description-label" htmlFor="countryDocumentRef">
                        {watch('countryDocumentRef') && parameters?.EXPEDITIONS_COUNTRY?.value}
                    </label>
                    <SpinnerMiddleware targetParameter={parameters?.EXPEDITIONS_COUNTRY}>
                        <Controller
                            control={control}
                            name="countryDocumentRef"
                            rules={{ required: parameters?.RQD_MSG_8?.value }}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    cacheOptions
                                    options={countriesList}
                                    placeholder={parameters?.EXPEDITIONS_COUNTRY?.value}
                                    getOptionValue={(option) => option.pk}
                                    getOptionLabel={(option) => option.name}
                                    styles={selectCustomStyles}
                                    className="is-invalid"
                                    onChange={(val) => {
                                        setCountryDocumentRef(val);
                                        setValue('countryDocumentRef', val);
                                    }}
                                    value={getValues('countryDocumentRef')}
                                />
                            )}
                        />
                    </SpinnerMiddleware>
                    {errors.countryDocumentRef?.message?.length > 0 && (
                        <Form.Control.Feedback type="invalid">
                            {errors.countryDocumentRef.message || parameters?.RQD_MSG_8?.value}
                        </Form.Control.Feedback>
                    )}
                </Form.Group>
            </Col>

            {/* Ciudad de expedición */}
            <Col lg={12}>
                <Form.Group className="mb-2" controlId="cityDocumentRef">
                    <label className="description-label" htmlFor="cityDocumentRef">
                        {watch('cityDocumentRef') && parameters?.EXPEDITIONS_CITY?.value}
                    </label>
                    <SpinnerMiddleware targetParameter={'parameters?.INF_MSG_190'}>
                        <Controller
                            control={control}
                            name="cityDocumentRef"
                            rules={{ required: parameters?.RQD_MSG_8?.value }}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    cacheOptions
                                    options={citiesListDoc}
                                    placeholder={parameters?.EXPEDITIONS_CITY?.value}
                                    getOptionValue={(option) => option.pk}
                                    getOptionLabel={(option) => option.name}
                                    styles={selectCustomStyles}
                                    isDisabled={disableCity}
                                    className="is-invalid"
                                    onChange={(val) => setValue('cityDocumentRef', val)}
                                    value={getValues('cityDocumentRef')}
                                />
                            )}
                        />
                    </SpinnerMiddleware>
                    {errors.cityDocumentRef?.message?.length > 0 && (
                        <Form.Control.Feedback type="invalid">
                            {errors.cityDocumentRef.message || parameters?.RQD_MSG_8?.value}
                        </Form.Control.Feedback>
                    )}
                </Form.Group>
            </Col>

            {/* Tipo de documento */}
            <Col lg={12}>
                <Form.Group className="mb-2" controlId="documentTypeRef">
                    <label className="description-label" htmlFor="documentTypeRef">
                        {watch('documentTypeRef') && parameters?.LBL_TYPE_DOC?.value}
                    </label>
                    <SpinnerMiddleware targetParameter={parameters?.EXPEDITIONS_COUNTRY}>
                        <Controller
                            control={control}
                            name="documentTypeRef"
                            rules={{ required: parameters?.RQD_MSG_8?.value }}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    cacheOptions
                                    options={documentTypeListRef}
                                    placeholder={parameters?.LBL_TYPE_DOC?.description_value}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.document_type}
                                    isDisabled={!getValues('cityDocumentRef')}
                                    styles={selectCustomStyles}
                                    className="is-invalid"
                                    onChange={(val) => setValue('documentTypeRef', val)}
                                    value={getValues('documentTypeRef')}
                                />
                            )}
                        />
                    </SpinnerMiddleware>
                    {errors.documentTypeRef?.message?.length > 0 && (
                        <MessageError message={errors?.documentTypeRef?.message} />
                    )}
                </Form.Group>
            </Col>

            {/* Número de documento */}
            <Col lg={12}>
                <Form.Group className="mb-3 mt-2" controlId="numberDocumentRef">
                    {watch('numberDocumentRef')?.length > 0 && (
                        <SpinnerMiddleware targetParameter={'parameters?.INF_MSG_156'}>
                            <label className="description-label" htmlFor="numberDocumentRef">
                                {parameters?.LBL_NUMBER_DOC?.value}
                            </label>
                        </SpinnerMiddleware>
                    )}
                    <InputFormControl
                        name="numberDocumentRef"
                        type="text"
                        rules={{ required: parameters?.RQD_MSG_8?.value }}
                        control={control}
                        placeholder={parameters?.LBL_NUMBER_DOC?.value}
                        error={errors?.numberDocumentRef}
                        border
                        customHeight="2.5rem"
                    />
                </Form.Group>
            </Col>

            {/* Fecha de expedición */}
            <Col lg={12}>
                <Form.Group className="mb-3" controlId="expeditionDateRef">
                    <label className="description-label" htmlFor="expeditionDateRef">
                        {parameters?.LBL_EXP_DATE?.value}
                    </label>
                    <InputFormControl
                        name="expeditionDateRef"
                        type="date"
                        control={control}
                        placeholder={parameters?.LBL_EXP_DATE?.value}
                        error={errors?.expeditionDateRef}
                        border
                        rules={{ required: parameters?.RQD_MSG_8?.value }}
                        customHeight="2.5rem"
                        defaultValue={getValues('expeditionDateRef')}
                        value={getValues('expeditionDateRef')}
                    />
                </Form.Group>
            </Col>

            {/* Carga de documento PDF */}
            <Col lg={12}>
                <Form.Group className="mb-3" controlId="documentFileRef">
                    {watch('documentFileRef') !== '0' && (
                        <label className="description-label" htmlFor="documentFileRef">
                            {parameters?.LBL_DOC_FILE?.value}
                        </label>
                    )}
                    <label
                        className="d-flex mt-3 w-100 justify-content-between cv-container"
                        style={{ borderBottom: '1px solid #ddd', paddingBottom: '8px' }}>
                        {activeFileNameRef ? (
                            <span style={{ width: 'inherit', textOverflow: 'ellipsis', marginRight: '15px' }}>
                                {fileNameRef}
                            </span>
                        ) : (
                            <span style={{ color: '#aaa', marginLeft: '10px' }}>
                                {parameters?.UPLOAD_DOC?.value}
                            </span>
                        )}
                        <input
                            style={{ display: 'none' }}
                            type="file"
                            id="documentFileRef"
                            name="documentFileRef"
                            accept=".pdf"
                            ref={inputFileRef}
                            onChange={() => handleLoadFileRef('documentFileRef')}
                        />
                        <input type="hidden" {...register('documentFileRef')} />
                        {fileNameRef?.length > 0 ? (
                            <FontAwesomeIcon
                                className="cirlce-xmark"
                                icon={faCircleXmark}
                                onClick={removeResource}
                            />
                        ) : (
                            <FontAwesomeIcon icon={faEllipsis} />
                        )}
                    </label>
                    {errorInvalidFileRef && (
                        <span className="label-inputs-required text-danger">
                            {parameters?.ERR_MSG_9?.value || 'Debe cargar un archivo .pdf'}
                        </span>
                    )}
                    {errorInvalidSizeRef && (
                        <MessageError
                            message={`${parameters?.ERR_MSG_10?.value} ${(DIV_LIMIT_FILE.limit_mb ?? parseInt(parameters?.LIMIT_FILE?.value)) / DIV_LIMIT_FILE.divisor} MB`}
                        />
                    )}
                    {errorEmptyFileRef && (
                        <MessageError message={parameters?.ERR_MSG_5?.description_value} />
                    )}
                </Form.Group>
            </Col>

            <div className="pt-2">
                <CustomCheck
                    onChange={() => handleCheck(!checkedTruthfulness)}
                    checked={checkedTruthfulness}
                    description="Declaro que la información proporcionada es verdadera y correcta."
                />
            </div>
            {empyCheck && (
                <MessageError message={parameters?.ERR_MSG_5?.description_value ?? 'El campo requerido'} />
            )}
        </>
    );
};

export default ReferenceForm;
